/* Collection V4.2: presentation only. Shopify owns collection membership, filters,
   prices, inventory and complete purchasable variant selection on the PDP. */
(() => {
 'use strict';
 const cycle = ['Raw Titanium', 'Gold', 'Rainbow'];
 const priority = [['Raw Titanium','Titanium'],['Black'],['Gold'],['Aqua Blue','Blue'],['Rainbow']];
 const selections = new Map(), openGroups = new Map(), failedImages = new Set();
 const colourLabel = name => name === 'Raw Titanium' ? 'Titanium' : name === 'Aqua Blue' ? 'Blue' : name;
 class TiWorksCollection {
  init = () => {
   this.section = document.querySelector('.tw-collections-v42');
   if (!this.section) return;
   this.sidebar = this.section.querySelector('.tw42-sidebar');
   this.trigger = this.section.querySelector('.tw42-filter-trigger');
   this.dialog = this.section.querySelector('.tw42-palette');
   this.sort = this.section.querySelector('.tw42-sort');
   this.sortSelect = this.sort.querySelector('select');
   this.sortTrigger = this.sort.querySelector('.tw42-sort-trigger');
   this.sortMenu = this.sort.querySelector('.tw42-sort-menu');
   this.sortTrigger.querySelector('[data-sort-label]').textContent = this.sortSelect.selectedOptions[0].textContent;
   this.sortTrigger.setAttribute('aria-label', `Sort by: ${this.sortSelect.selectedOptions[0].textContent}`);
   this.sortSelect.hidden = true;
   this.sort.querySelector('label').htmlFor = this.sortTrigger.id;
   this.sort.classList.add('tw42-sort-enhanced');
   this.sortTrigger.hidden = false;
   this.cards = [...this.section.querySelectorAll('.tw42-product-card')];
   this.cards.forEach(card => {
    card.colours = JSON.parse(card.querySelector('.tw42-colour-data').textContent);
    const img = card.querySelector('.tw42-image');
    if (img) {
     card.originalImage = card.dataset.originalImage || img.currentSrc || img.src;
     const initialSource = [...card.querySelectorAll('picture source')].find(source => matchMedia(source.media).matches);
     img.dataset.colourSource = initialSource?.dataset.image || img.dataset.image || img.src;
    }
    const representatives = priority.map(names => card.colours.find(c => names.includes(c.name))).filter(Boolean);
    for (const colour of card.colours) { if (representatives.length >= 5) break; if (!representatives.includes(colour)) representatives.push(colour); }
    const group = card.querySelector('.tw42-swatches');
    group.replaceChildren(...representatives.map(colour => this.swatch(card, colour)));
    const extra = card.colours.length - representatives.length;
    if (extra > 0) {
     const more = document.createElement('button'); more.type = 'button'; more.className = 'tw42-more-colours';
     more.textContent = `+${extra}`; more.setAttribute('aria-label', `Show all ${card.colours.length} colours for ${card.dataset.title}`);
     group.append(more);
    }
   });
   this.section.querySelectorAll('details').forEach(details => {
    const key = details.dataset.filterKey || 'category';
    if (openGroups.has(key)) details.open = openGroups.get(key);
    if (details.querySelector('input:checked')) details.open = true;
    details.addEventListener('toggle', () => openGroups.set(key, details.open));
   });
   this.resizeObserver?.disconnect();
   this.resizeObserver = new ResizeObserver(() => this.scheduleRows());
   const grid = this.section.querySelector('.tw42-product-grid');
   if (grid) this.resizeObserver.observe(grid);
   this.scheduleRows();
   if (!this.bound) {
    document.addEventListener('click', this.onClick);
    document.addEventListener('pointerover', this.onPointerOver);
    document.addEventListener('pointerout', this.onPointerOut);
    document.addEventListener('keydown', this.onKeydown);
    document.addEventListener('focusin', event => { if (!this.sort.contains(event.target)) this.closeSort(); });
    window.addEventListener('resize', () => {
     if (innerWidth >= 1024) this.closeSidebarFilter();
     this.scheduleRows();
    });
    document.fonts.ready.then(this.scheduleRows);
    this.bound = true;
   }
  };
  swatch(card, colour, expanded = false) {
   const button = document.createElement('button');
   button.type = 'button'; button.className = 'tw42-swatch'; button.dataset.color = colour.name;
   button.dataset.productId = card.dataset.productId; button.dataset.available = String(colour.available);
   button.setAttribute('aria-label', `Preview ${colourLabel(colour.name)} for ${card.dataset.title}${colour.available ? '' : ' — sold out'}${colour.image ? '' : ' — image unavailable'}`);
   button.title = `${colourLabel(colour.name)}${colour.available ? '' : ' — sold out'}${colour.image ? '' : ' — image unavailable'}`;
   button.setAttribute('aria-pressed', String(card.dataset.displayColor === colour.name));
   button.disabled = !colour.image;
   const dot = document.createElement('span'); dot.className = 'tw42-swatch-dot'; dot.style.backgroundColor = colour.swatch;
   if (colour.texture) dot.style.backgroundImage = `url(${JSON.stringify(colour.texture)})`;
   button.append(dot);
   if (expanded) { const label = document.createElement('span'); label.textContent = `${colourLabel(colour.name)}${colour.available ? '' : ' (sold out)'}${colour.image ? '' : ' (no image)'}`; button.append(label); }
   return button;
  }
  scheduleRows = () => {
   cancelAnimationFrame(this.rowFrame);
   this.rowFrame = requestAnimationFrame(this.updateRows);
  };
  updateRows = () => {
   let previousTop, row = -1;
   const tops = this.cards.map(card => Math.round(card.getBoundingClientRect().top));
   this.cards.forEach((card, index) => {
    const top = tops[index];
    if (previousTop === undefined || Math.abs(top - previousTop) > 2) { row++; previousTop = top; }
    card.dataset.row = String(row + 1); card.dataset.defaultColor = cycle[row % cycle.length];
    this.showColor(card, card.hoverColour || this.baseColor(card), !!card.hoverColour);
   });
  };
  baseColor(card) {
   const selected = selections.get(card.dataset.productId);
   if (selected && card.colours.some(c => c.name === selected)) return selected;
   const colourFilters = [...this.section.querySelectorAll('input:checked')].filter(input => /^filter\.v\.option\.colou?r$/i.test(input.name));
   if (colourFilters.length === 1 && card.colours.some(c => c.name === colourFilters[0].value)) return colourFilters[0].value;
   return card.dataset.defaultColor;
  }
  showColor(card, name, preview = false) {
   const usable = c => c?.image && !failedImages.has(c.image);
   const requested = card.colours.find(c => c.name === name || (name === 'Raw Titanium' && c.name === 'Titanium'));
   const colour = usable(requested) ? requested : card.colours.find(c => (c.name === 'Raw Titanium' || c.name === 'Titanium') && usable(c)) || card.colours.find(usable);
   const img = card.querySelector('.tw42-image');
   const source = colour?.image || card.originalImage;
   card.dataset.displayColor = colour?.name || '';
   card.dataset.requestedColor = name || '';
   card.dataset.fallback = String(!usable(requested));
   card.dataset.mode = preview ? 'preview' : selections.has(card.dataset.productId) ? 'selected' : 'row';
   if (img && source) {
    // Keep the browser's responsive choice. Initial <picture> already has the
    // correct row colour at each breakpoint, so initialization needs no swap.
    const changed = img.dataset.colourSource !== source;
    img.onload = () => { card.dataset.imageLoaded = 'true'; };
    img.onerror = () => {
     failedImages.add(source);
     if (source === card.originalImage) { card.dataset.imageLoaded = 'error'; img.onerror = null; return; }
     this.showColor(card, name, preview);
    };
    if (changed) {
     const srcset = this.responsiveSrcset(source);
     // Update active <source> before <img> to avoid fetching an intermediate image.
     card.querySelectorAll('picture source').forEach(item => { item.srcset = srcset; });
     img.srcset = srcset;
     img.dataset.colourSource = source;
     card.dataset.imageLoaded = 'loading'; img.src = source;
    } else if (img.complete) {
     if (img.naturalWidth) card.dataset.imageLoaded = 'true';
     else if (img.currentSrc) img.onerror();
    }
   }
   if (img) img.alt = `${card.dataset.title}${colour ? ` — ${colour.name}` : ''}`;
   card.querySelector('.tw42-colour-status').textContent = `${colour?.name || 'Product image'}${card.dataset.fallback === 'true' ? ' — alternate image unavailable' : ''}`;
   card.querySelectorAll('.tw42-swatch').forEach(button => {
    button.setAttribute('aria-pressed', String(button.dataset.color === colour?.name));
    button.classList.toggle('previewing', preview && button.dataset.color === colour?.name);
   });
  }
  responsiveSrcset(source) {
   // Every candidate is a Shopify CDN size of this same product image.
   if (!/[?&]width=\d+/.test(source)) return '';
   return [175,350,535,700].map(width => `${source.replace(/([?&])width=\d+/, `$1width=${width}`)} ${width}w`).join(', ');
  }
  onPointerOver = event => {
   const button = event.target.closest('.tw42-product-card .tw42-swatch');
   if (!button || button.disabled || event.pointerType === 'touch' || !matchMedia('(min-width:1024px) and (hover:hover)').matches) return;
   const card = button.closest('.tw42-product-card');
   card.hoverColour = button.dataset.color;
   this.showColor(card, card.hoverColour, true);
  };
  onPointerOut = event => {
   const button = event.target.closest('.tw42-product-card .tw42-swatch');
   if (!button || button.contains(event.relatedTarget)) return;
   const card = button.closest('.tw42-product-card'); card.hoverColour = null;
   this.showColor(card, this.baseColor(card));
  };
  onClick = event => {
   if (!event.target.closest('.tw42-sort')) this.closeSort();
   const button = event.target.closest('button');
   if (event.target.closest('.tw42-backdrop')) this.closeSidebarFilter();
   if (event.target.closest('.tw42-browse a')) this.closeSidebarFilter();
   if (!button || !button.closest('.tw-collections-v42')) return;
   if (button.matches('.tw42-sort-trigger')) {
    if (this.sortMenu.hidden) this.openSort(); else this.closeSort(true);
   }
   if (button.matches('[data-sort-value]')) {
    const value = button.dataset.sortValue;
    this.closeSort(true);
    if (this.sortSelect.value !== value) {
     this.sortSelect.value = value;
     this.sortTrigger.querySelector('[data-sort-label]').textContent = button.querySelector('span').textContent;
     this.sortTrigger.setAttribute('aria-label', `Sort by: ${button.querySelector('span').textContent}`);
     this.sortMenu.querySelectorAll('[data-sort-value]').forEach(item => item.setAttribute('aria-checked', String(item.dataset.sortValue === value)));
     this.sortSelect.dispatchEvent(new Event('change', {bubbles:true}));
    }
   }
   if (button.matches('.tw42-filter-trigger')) this.openSidebarFilter();
   if (button.matches('.tw42-close,.tw42-apply')) this.closeSidebarFilter();
   if (button.matches('.tw42-filter-more')) {
    const options = button.closest('.tw42-filter-options'); const show = !options.classList.contains('tw42-show-all');
    options.classList.toggle('tw42-show-all', show); button.setAttribute('aria-expanded', String(show));
    button.textContent = show ? 'Show fewer head styles' : `Show all head styles (${button.dataset.total})`;
   }
   if (button.matches('.tw42-more-colours')) {
    this.paletteCard = button.closest('.tw42-product-card');
    this.dialog.querySelector('.tw42-product-caption').textContent = this.paletteCard.dataset.title;
    this.dialog.querySelector('ul').replaceChildren(...this.paletteCard.colours.map(colour => {
     const li = document.createElement('li'); li.append(this.swatch(this.paletteCard, colour, true)); return li;
    }));
    this.dialog.showModal();
   }
   if (button.matches('.tw42-swatch') && !button.disabled) {
    const card = this.cards.find(c => c.dataset.productId === button.dataset.productId);
    if (!card) return;
    selections.set(card.dataset.productId, button.dataset.color); card.hoverColour = null;
    this.showColor(card, this.baseColor(card));
    if (this.dialog.open) this.dialog.close();
   }
   if (button.matches('.tw42-dialog-close')) this.dialog.close();
   if (button.matches('.tw42-palette-reset') && this.paletteCard) {
    selections.delete(this.paletteCard.dataset.productId); this.paletteCard.hoverColour = null;
    this.showColor(this.paletteCard, this.baseColor(this.paletteCard)); this.dialog.close();
   }
  };
  openSort = (last = false) => {
   this.sortMenu.hidden = false;
   this.sortTrigger.setAttribute('aria-expanded', 'true');
   const items = [...this.sortMenu.querySelectorAll('[data-sort-value]')];
   (last ? items.at(-1) : items.find(item => item.getAttribute('aria-checked') === 'true') || items[0]).focus();
  };
  closeSort = (restoreFocus = false) => {
   if (!this.sortMenu || this.sortMenu.hidden) return;
   this.sortMenu.hidden = true;
   this.sortTrigger.setAttribute('aria-expanded', 'false');
   if (restoreFocus) this.sortTrigger.focus();
  };
  openSidebarFilter = () => {
   if (innerWidth >= 1024 || this.sidebar.classList.contains('open')) return;
   this.previousOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden';
   this.section.classList.add('sidebar-open'); this.sidebar.classList.add('open');
   this.section.querySelector('.tw42-backdrop').classList.add('open'); this.trigger.setAttribute('aria-expanded','true');
   this.sidebar.setAttribute('role','dialog'); this.sidebar.setAttribute('aria-modal','true');
   this.inertNodes = [...document.querySelectorAll('.m-header,.m-footer,.tw42-intro,.tw42-toolbar,.tw42-catalog')].filter(el => !el.contains(this.sidebar));
   this.inertNodes.forEach(el => { el.dataset.tw42WasInert = String(el.inert); el.inert = true; });
   this.sidebar.querySelector('.tw42-close').focus();
  };
  closeSidebarFilter = () => {
   if (!this.sidebar?.classList.contains('open')) return;
   this.section.classList.remove('sidebar-open'); this.sidebar.classList.remove('open');
   this.section.querySelector('.tw42-backdrop').classList.remove('open'); this.trigger.setAttribute('aria-expanded','false');
   this.sidebar.removeAttribute('role'); this.sidebar.removeAttribute('aria-modal');
   document.body.style.overflow = this.previousOverflow || '';
   this.inertNodes?.forEach(el => { el.inert = el.dataset.tw42WasInert === 'true'; delete el.dataset.tw42WasInert; });
   this.trigger.focus();
  };
  onKeydown = event => {
   if (event.target === this.sortTrigger && ['ArrowDown','ArrowUp'].includes(event.key)) {
    event.preventDefault(); this.openSort(event.key === 'ArrowUp'); return;
   }
   if (!this.sortMenu.hidden && this.sort.contains(event.target)) {
    if (event.key === 'Escape') { event.preventDefault(); this.closeSort(true); return; }
    if (event.key === 'Tab') { this.closeSort(true); return; }
    const items = [...this.sortMenu.querySelectorAll('[data-sort-value]')];
    const index = items.indexOf(event.target);
    if (['ArrowDown','ArrowUp','Home','End'].includes(event.key)) {
     event.preventDefault();
     const next = event.key === 'Home' ? 0 : event.key === 'End' ? items.length - 1 : (index + (event.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
     items[next].focus(); return;
    }
   }
   if (!this.sidebar.classList.contains('open')) return;
   if (event.key === 'Escape') this.closeSidebarFilter();
   if (event.key !== 'Tab') return;
   const focusable = [...this.sidebar.querySelectorAll('a,button,input,select,summary')].filter(el => !el.disabled && el.getClientRects().length);
   const first = focusable[0], last = focusable.at(-1);
   if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
   else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  };
 }
 const initialize = () => { if (document.querySelector('.tw-collections-v42')) { MinimogTheme.Collection = new TiWorksCollection(); MinimogTheme.Collection.init(); } };
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true}); else initialize();
})();
